/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber21Small = createReactComponent("number-21-small", "IconNumber21Small", [
  ["path", { d: "M15 10l2 -2v8", key: "svg-0" }],
  [
    "path",
    {
      d: "M7 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3",
      key: "svg-1"
    }
  ]
]);

export { IconNumber21Small as default };
//# sourceMappingURL=IconNumber21Small.js.map
